import styled from '@emotion/styled';
import { color, position } from 'styled-system';
import type { ColorProps, FlexProps, PositionProps } from 'styled-system';

import { Flex } from 'common/components/Flex';

const Container = styled(Flex)<FlexProps & ColorProps & PositionProps>`
  ${color};
  ${position};
`;

export default Container;
